<template>
  <b-card>
    <div class="m-2">
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>Show</label>
          <v-select
            v-model="perPage"
            :options="perPageOptions"
            label="label"
            :reduce="opt => opt.value"
            :clearable="false"
            class="per-page-selector d-inline-block ml-50 mr-1"
          />
          <b-button variant="primary" :to="{ name: 'admin-notification-center-create' }">
            Create Notification
          </b-button>
        </b-col>
      </b-row>
    </div>
    <div class="d-none d-md-flex">
      <b-table
        responsive
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :items="resultDataTable"
        :fields="fields"
        :no-local-sorting="true"
        @sort-changed="sortingChanged"
        :busy="isBusy"
        class="w-100"
      >
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
            <strong class="text-secondary">Loading...</strong>
          </div>
        </template>
        <template #cell(status)>
          <b-button
            variant="success"
            size="sm"
            class="status-btn"
          >
            Success
          </b-button>
        </template>
        <template #cell(action)="row">
          <div class="d-flex justify-content-start">
            <b-button
              type="button"
              class="mr-1 txt-xs-2"
              size="sm"
              variant="primary"
              @click="DetailRequest(row.item.id)"
            >
              <feather-icon size="14" icon="BookIcon" />
            </b-button>
          </div>
        </template>

        <template #cell(sendByDivision)="data">
          <div v-html="formatArray(data.item.sendByDivision, 'primary')"></div>
        </template>
        <template #cell(to)="data">
          <div v-html="formatArray(data.item.sendToAll ? data.item.sendToAll : data.item.to, 'primary')"></div>
        </template>
        <template #cell(cc)="data">
          <div v-html="formatArray(data.item.cc, 'warning')"></div>
        </template>
        <template #cell(bcc)="data">
          <div v-html="formatArray(data.item.bcc, 'warning')"></div>
        </template>
        <template #cell(createdAt)="row">
          <div>
            {{ row.item.createdAt ? $moment(row.item.createdAt).format('dddd, Do MMMM YYYY') : '-' }}
          </div>
        </template>
      </b-table>
    </div>

    <!-- Mobile screen -->
    <div class="d-flex d-md-none flex-column">
      <!-- Loading -->
      <div v-if="isBusy" class="text-center text-danger my-2">
        <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
        <strong class="text-secondary">Loading...</strong>
      </div>
      <!-- Data -->
      <div v-if="!isBusy && resultDataTable.length == 0" class="text-center text-danger my-2">
        <strong class="text-secondary">No data</strong>
      </div>
      <b-row
        v-if="!isBusy && resultDataTable.length > 0"
        v-for="(item, index) in resultDataTable"
        :key="item.id"
        class="mb-3 list-item"
      >
        <b-col cols="12" class="d-flex flex-wrap justify-content-end align-items-center mb-1" style="gap: 1rem;">
          <strong class="flex-grow-1 truncate">{{ item.subject }}</strong>
          <div>
            <b-button
              type="button"
              class="mr-1 txt-xs-2"
              size="sm"
              variant="primary"
              @click="DetailRequest(item.id)"
            >
              <feather-icon size="14" icon="BookIcon" />
            </b-button>
          </div>
        </b-col>
        <b-col cols="12" class="d-flex flex-wrap">
          <div style="font-size: 0.75rem;">
            <p>
              <strong>DIVISION: </strong>
              <span v-html="formatArray(item.sendByDivision, 'primary')"></span>
            </p>
            <p>
              <strong>TO: </strong>
              <span v-html="formatArray(item.sendToAll ? item.sendToAll : item.to, 'primary')"></span>
            </p>
            <p>
              <strong>CC: </strong>
              <span v-html="formatArray(item.cc, 'warning')"></span>
            </p>
            <p>
              <strong>BCC: </strong>
              <span v-html="formatArray(item.bcc, 'warning')"></span>
            </p>
            <p>
              <strong>STATUS: </strong>
              <b-button
                variant="success"
                size="sm"
                class="status-btn"
              >
                Success
              </b-button>
            </p>
            <p>
              <strong>CREATED AT: </strong>
              {{ item.createdAt ? $moment(item.createdAt).format('dddd, Do MMMM YYYY') : '-' }}
            </p>
          </div>
        </b-col>
      </b-row>
    </div>
    <div class="mx-2 mb-2">
      <b-row>
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">
            Showing {{ pagination.from }} to {{ pagination.to }} of
            {{ pagination.total }} entries
          </span>
        </b-col>

        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="pagination.total"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
            @input="changePage"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import {
  BCard, BCardBody, BRow, BCol, BButton, BTable,
  BPagination, BSpinner
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { generateToken } from '@/auth/helperAuth'

export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BButton,
    BTable,
    BPagination,
    BSpinner,
    vSelect,
  },
  data() {
    return {
      token: "",
      currentPage: 1,
      isBusy: false,
      perPage: 10,
      sortBy: 'CREATED_DATE',
      sortDesc: true,
      perPageOptions: [10, 20, 30, 50, 100],
      pagination: { from: 1, to: 10, total: 0 },
      fields: [
        { key: 'subject', label: 'Subject' },
        { key: 'sendByDivision', label: 'Division' },
        { key: 'to', label: 'To' },
        { key: 'cc', label: 'CC' },
        { key: 'bcc', label: 'BCC' },
        { key : 'status', label: 'Status'},
        { key: 'createdAt', label: 'Created At', sortable: true },
        'action',
      ],
      resultDataTable: [],
    }
  },
  directives: { Ripple },
  created() {
    const payload = {
      client: "product-catalog-fe",
      kode: this.$store.getters['oauth/getActiveUser'].id.toString(),
      user: this.$store.getters['oauth/getActiveUser'].name,
      role: this.$store.getters['oauth/getActiveUser'].role,
    };
    this.token = generateToken(payload)
  },
  watch: {
    perPage() {
      this.currentPage = 1
      this.fetchResultDataTable()
    },
    currentPage() {
      this.fetchResultDataTable()
    },
  },
  mounted() {
    this.fetchResultDataTable()
  },
  methods: {
    async fetchResultDataTable() {
      this.isBusy = true
      try {
        const { data } = await this.$http.get(
          `${process.env.VUE_APP_API_HELPER_URL}/notificationCenter/featuresBlast`,
          {
            params: {
              page: this.currentPage,
              limit: this.perPage,
              sortBy: this.sortBy,
              sortDesc: this.sortDesc,
            },
            headers: {
              'Client-Device': 'browser',
              'Authorization': `${this.token}`
            },
          }
        )
        this.pagination.total = data.pagination.total
        this.pagination.from = data.pagination.from
        this.pagination.to = data.pagination.to
        this.resultDataTable = data.data
        const baseOptions = [10, 20, 30, 50, 100]
        this.perPageOptions = baseOptions
          .filter(opt => opt < this.pagination.total)
          .map(opt => ({ label: opt.toString(), value: opt }))

        this.perPageOptions.push({ label: 'See All', value: this.pagination.total })
      } catch (err) {
        console.error(err)
      } finally {
        this.isBusy = false
      }
    },
    changePage(page) {
      this.currentPage = page
    },
    sortingChanged({ sortBy, sortDesc }) {
      this.sortBy = sortBy
      this.sortDesc = sortDesc
      this.fetchResultDataTable()
    },
    formatArray(value, color) {
      if (value && value.length > 0) {
        let badges = `<span class="badge badge-${color}" style="margin-left:2px">${value[0]}</span>`
        if (value.length > 1) {
          badges += `<span class="badge badge-${color}" style="margin-left:2px">...</span>`
        }
        return badges
      }
      return ''
    },
    DetailRequest(id) {
      this.$router.push(`/admin/notification-center/${id}`)
    },
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.status-btn {
  font-size: 0.75rem !important;
  line-height: 1rem !important;
  padding: 0.1rem 0.4rem !important;
  height: auto !important;
  border-radius: 4px !important;
}

</style>
